// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITaxFormMailingHistoryDto
 */
export interface ITaxFormMailingHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof ITaxFormMailingHistoryDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ITaxFormMailingHistoryDto
     */
    tax_form_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITaxFormMailingHistoryDto
     */
    tax_form_type?: ITaxFormMailingHistoryDtoTaxFormTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ITaxFormMailingHistoryDto
     */
    mailed_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ITaxFormMailingHistoryDto
     */
    status?: ITaxFormMailingHistoryDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum ITaxFormMailingHistoryDtoTaxFormTypeEnum {
    TAX_FORM_1099 = 'TAX_FORM_1099',
    TAX_FORM_5498 = 'TAX_FORM_5498',
    TAX_FORM_EXCESS_1099 = 'TAX_FORM_EXCESS_1099'
}
/**
* @export
* @enum {string}
*/
export enum ITaxFormMailingHistoryDtoStatusEnum {
    PENDING = 'PENDING',
    SENT = 'SENT'
}


/**
 * Check if a given object implements the ITaxFormMailingHistoryDto interface.
 */
export function instanceOfITaxFormMailingHistoryDto(value: object): value is ITaxFormMailingHistoryDto {
    return true;
}

export function ITaxFormMailingHistoryDtoFromJSON(json: any): ITaxFormMailingHistoryDto {
    return ITaxFormMailingHistoryDtoFromJSONTyped(json, false);
}

export function ITaxFormMailingHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITaxFormMailingHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tax_form_id': json['tax_form_id'] == null ? undefined : json['tax_form_id'],
        'tax_form_type': json['tax_form_type'] == null ? undefined : json['tax_form_type'],
        'mailed_at': json['mailed_at'] == null ? undefined : (new Date(json['mailed_at'])),
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function ITaxFormMailingHistoryDtoToJSON(json: any): ITaxFormMailingHistoryDto {
    return ITaxFormMailingHistoryDtoToJSONTyped(json, false);
}

export function ITaxFormMailingHistoryDtoToJSONTyped(value?: ITaxFormMailingHistoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tax_form_id': value['tax_form_id'],
        'tax_form_type': value['tax_form_type'],
        'mailed_at': value['mailed_at'] == null ? undefined : ((value['mailed_at']).toISOString()),
        'status': value['status'],
    };
}

